<template>
  <div>
    <v-expansion-panels v-for="modality in dxModalities" v-if="modality" :key="modality">
      <v-expansion-panel style="margin-bottom: 12px">
        <v-expansion-panel-header style="color: darkblue; font-size: 1rem">
          <span style="text-align: left">{{ modality }} </span>
          <span style="text-align: right">&nbsp; </span>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-card flat style="padding: 0px">
            <v-card-text style="padding: 0px">
              <!-- ***** -->
              <v-expansion-panels>
                <v-expansion-panel v-for="option in allFDRI.filter((option) => option.RSLT.modality === modality)"
                  :key="option.ID">
                  <v-expansion-panel-header style="font-size: 0.85rem">
                    <span style="text-align: left">
                      <span :style="{
                        fontSize: '.81rem',
                        color: getDesignationColor(getDesignation(option.REQ))
                      }">{{ getDesignation(option.REQ) }}&nbsp;</span>
                      <span>&nbsp; | &nbsp;</span>
                      <span style="font-size: 0.94rem; color: brown">{{ option.RSLT.observation }}</span>
                    </span>
                    <span style="font-size: 0.65rem; color: #7e7e7e; margin-right: 20px; text-align: right">click
                      options</span>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-card flat>
                      <v-card-text style="padding: 0px">
                        <h4>Diagnoses</h4>
                        <div v-for="(diagnosis, dIndex) in option.RSLT.diagnoses"
                          :id="`diagnosis-${option.RSLT.id}-${dIndex}`" :key="`diagnosis-${option.RSLT.id}-${dIndex}`"
                          class="checkbox-item">
                          <label>
                            <input :value="diagnosis" :checked="selectedDiagnoses.some(
                              (item) => item.optionID === option.RSLT.file_path && item.value === `${option.RSLT.eye_affected}.${diagnosis}`
                            )
                              " type="checkbox"
                              @change="chkboxChangeD(option.RSLT, diagnosis, getDesignation(option.REQ), $event)" />
                            {{ diagnosis.split("(")[0] }} &nbsp;
                            <a :href="`https://www.icd10data.com/search?s=${diagnosis.split('(')[1] ? diagnosis.split('(')[1].split(')')[0] : ''
                              }`" target="_blank">
                              ({{ diagnosis.split("(")[1] ? diagnosis.split("(")[1].split(")")[0] : "" }})
                            </a>
                          </label>
                        </div>

                        <h4>Recommendations</h4>
                        <div v-for="(recommendation, rIndex) in option.RSLT.recommendations"
                          :key="`recommendation-${option.RSLT.ID}-${rIndex}`" class="checkbox-item">
                          <label>
                            <input :value="recommendation" :checked="selectedRecommendations.some(
                              (item) => item.optionID === option.ID && item.value === recommendation
                            )
                              " type="checkbox" @change="chkboxChangeR(option.RSLT, recommendation, $event)" />
                            {{ recommendation }}
                          </label>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>

                  <v-divider></v-divider>
                </v-expansion-panel>
              </v-expansion-panels>
              <!--  -->
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div align="center">
      <md-button class="md-button md-sm md-primary" style="margin-right: 15px" @click="dxClear">clear</md-button>
      <md-button class="md-button md-sm md-danger" style="margin-right: 15px" @click="dxCancel">Cancel</md-button>
      <md-button :disabled="btnSubmitDisable" :class="btnSubmitDisable ? 'md-button md-simple' : 'md-button md-success'"
        class="md-button md-sm md-success" @click="dxSubmit(true)">
        submit
      </md-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { bus } from "@/main"
export default {
  name: "DxOptions",
  data() {
    return {
      btnSubmitDisable: false,
      selectedFindings: [],
      selectedDiagnoses: [],
      selectedRecommendations: [],
      selectedICD10: [],
      unmarkedDiagnoses: [],
      unmarkedRecommendations: [],
      dxCards: [],
      modalities: [
        "externalPhoto",
        "corneaPhoto",
        "pachymetryPhoto",
        "opacityPhoto",
        "fundusPhoto",
        "maculaPhoto",
        "nervePhoto"
      ]
    }
  },

  computed: {
    ...mapGetters(["eval", "screening", "omniPhoto", "omniSelected", "dxOptionsList"]),
    allFDRI() {
      // return this.dxOptionsList
      // console.log("List DxOptions : ", this.dxOptionsList)
      return Array.isArray(this.dxCards)
        ? this.dxCards.filter((option) => option.RSLT != undefined && option.RSLT.error !== "File not found")
        : []
    },
    dxModalities() {
      let mModalities = Array.from(new Set(this.allFDRI.map((item) => item.RSLT.modality)))
      // console.log("List Modalities : ", mModalities)
      return mModalities
    }
  },
  mounted: function () {
    this.getObservations()
    bus.$on("dxOptionsChanged", () => {
      this.getObservations()
    })
  },
  methods: {
    getDesignation(req) {
      if (req.indexOf("mh") > -1) {
        return ""
      } else if (req.indexOf("fh") > -1) {
        return ""
      } else if (req.indexOf("OD") > -1) {
        return "OD"
      } else if (req.indexOf("OS") > -1) {
        return "OS"
      } else if (req.indexOf("OU") > -1) {
        return "OU"
      } else {
        return req
      }
    },
    getDesignationColor(designation) {
      switch (designation) {
        case "OD":
          return "darkgreen"
        case "OS":
          return "darkorange"
        case "OU":
          return "darkviolet"
        default:
          return "black" // or any default color you prefer
      }
    },
    dxCancel() {
      bus.$emit("closeDxOptions")
    },
    dxSubmit(swClose) {
      bus.$emit("dxSubmit", {
        findings: this.selectedFindings,
        diagnoses: this.selectedDiagnoses,
        unmarkedDiagnoses: this.unmarkedDiagnoses,
        recommendations: this.selectedRecommendations,
        unmarkedRecommendations: this.unmarkedRecommendations,
        icd10: this.selectedICD10
      })

      if (!this.screening.diagnosis) {
        this.screening.diagnosis = {}
      }
      this.screening.diagnosis.diagnosis = this.selectedDiagnoses.map(i => i.value.substring(3)).join(', <br />')

      if (swClose) {
        bus.$emit("closeDxOptions")
      }
    },
    dxClear() {
      this.eval.final_Findings = []
      this.eval.final_Recommendations = []

      this.modalities.forEach((M) => {
        this.eval[M].diagnosesOD = []
        this.eval[M].diagnosesOS = []
        this.eval[M].diagnosesOU = []
        this.eval[M].recommendOD = []
        this.eval[M].recommendOS = []
      })

      this.unmarkedDiagnoses = [...this.selectedDiagnoses.map(x => x.value.substring(3))]
      this.unmarkedRecommendations = [...this.selectedRecommendations.map(x => x.value.substring(3))]

      this.selectedFindings = []
      this.selectedDiagnoses = []
      this.selectedRecommendations = []
      this.selectedICD10 = []

      this.btnSubmitDisable = false

      bus.$emit("omniReset")

      ////
      let sectionArr = ["External", "Cornea", "Pachymetry", "Opacity", "Fundus", "Macula", "Nerve"]
      sectionArr.forEach((section) => {
        this.omniPhoto(section).fIDs = []
        this.omniPhoto(section).fIDs = []

        this.omniPhoto(section).findingsOD = []
        this.omniPhoto(section).findingsOS = []
        this.omniPhoto(section).findingsOU = []
        this.omniPhoto(section).diagnosesOD = []
        this.omniPhoto(section).diagnosesOS = []
        this.omniPhoto(section).diagnosesOU = []
        this.omniPhoto(section).recommendOD = []
        this.omniPhoto(section).recommendOS = []
        //console.log("itter:", section)
      })
      this.$store.dispatch("loadSummary", null)
      ////

      this.dxSubmit(false)

      bus.$emit("dxOptionsChanged", true)
      bus.$emit("clearDxOptions", true)
      //
    },
    chkboxChangeF(option, finding, eye, event) {
      this.updateSelection(this.selectedFindings, null, option.file_path, eye + "." + finding, event.target.checked)
      // console.log("F: ", finding, this.selectedFindings)
    },
    chkboxChangeD(option, diagnosis, eye, event) {
      this.updateSelection(this.selectedDiagnoses, this.unmarkedDiagnoses, option.file_path, eye + "." + diagnosis, event.target.checked)
      //console.log("D: ", eye, diagnosis, this.selectedDiagnoses)
    },
    chkboxChangeR(option, recommendation, event) {
      this.updateSelection(this.selectedRecommendations, this.unmarkedRecommendations, option.file_path, recommendation, event.target.checked)
      //console.log("R: ", recommendation, this.selectedRecommendations)
    },
    chkboxChangeI(option, icd, event) {
      this.updateSelection(this.selectedICD10, null, option.file_path, icd, event.target.checked)
      //console.log("I: ", icd, this.selectedICD10)
    },

    updateSelection(selectedArray, unmarkedArray, optionID, value, isChecked) {
      const index = selectedArray.findIndex((item) => item.optionID === optionID && item.value === value)
      const unmarkedIndex = unmarkedArray !== null ? unmarkedArray.findIndex((item) => item.optionID === optionID && item.value === value) : null

      if (isChecked && index === -1) {
        selectedArray.push({ optionID, value })
        if (unmarkedArray !== null && unmarkedIndex !== -1) unmarkedArray.splice(unmarkedIndex, 1)
      } else if (!isChecked && index !== -1) {
        selectedArray.splice(index, 1)
        if (unmarkedArray !== null && unmarkedIndex === -1) unmarkedArray.push(value.substring(3))
      }
    },

    async getObservations() {
      // if (this.omniSelected.length === 0) {
      //   return // do nothing
      // }

      // ADD MEDICAL HISTORY (STATIC - TESTING ONLY)
      //this.omniSelected.push("mh11", "fh31")

      var deDupeList = this.dxOptionsList

      // store unique IDs.Extensions
      const idMap = new Map()

      deDupeList.forEach((item) => {
        const [id, extension] = [item.RSLT.id, item.RSLT.eye_affected]
        if (id && extension) {
          if (!idMap.has(id)) {
            idMap.set(id, new Set())
          }
          idMap.get(id).add(extension)
        }
      })

      // Create the final list with combined duplicates
      const finalList = []
      idMap.forEach((extensions, id) => {
        if (extensions.size === 2 && extensions.has("OD") && extensions.has("OS")) {
          finalList.push(`${id}.OU`)
        } else {
          extensions.forEach((ext) => finalList.push(`${id}.${ext}`))
        }
      })

      // console.log("Final De-duped List: ", finalList)

      const url = `${String(process.env.VUE_APP_URL)}/dx-cards/m_fdri/${finalList}`
      const config = { headers: { "Content-Type": "application/json" } }

      const data = null
      const vm = this

      try {
        let response = { data: [] }
        if (finalList && finalList.length) {
          response = await window.axios.get(url, data, config)
        }
        const existingIds = new Set(this.dxOptionsList.map((item) => item.REQ))
        const newItems = (response.data || []).filter((item) => {
          const itemId = item.REQ
          return !existingIds.has(itemId) && item.RSLT.eye_affected !== "OU"
        })
        if (newItems.length > 0) {
          const updatedList = [...this.dxOptionsList, ...newItems]
          this.$store.commit("UPDATE_DX_OPTIONS", updatedList)
        }

        this.dxCards = []
        for (const c of response.data) {
          if (!this.dxCards.find((x) => x.RSLT.id === c.RSLT.id)) {
            this.dxCards.push(c)
          }
        }

        const screeningDiagnosis = (this.screening.diagnosis && this.screening.diagnosis.diagnosis) || ''
        for (const i of this.dxCards) {
          for (const diagnose of i.RSLT.diagnoses) {
            if (screeningDiagnosis.includes(diagnose)) {
              this.selectedDiagnoses.push({
                optionID: i.RSLT.file_path,
                value: `${i.RSLT.eye_affected}.${diagnose}`
              })
            }
          }
        }
      } catch (error) {
        console.log("error", error)
        vm.status = "An error occurred: " + error
        // console.log(vm.status)
      }
    }
  }
}
</script>

<style scoped>
.v-input--selection-controls {
  margin: 0;
  padding: 0;
}

.v-input--selection-controls .v-input__slot {
  margin: 0;
  padding: 0;
}

.v-label {
  font-size: 0.8rem;
  line-height: 0.9rem;
  text-align: left;
}

h4 {
  text-align: left;
  font-size: 0.96rem;
  color: black;
  font-weight: 400;
  margin-top: 16px;
  margin-bottom: 6px;
}

/* New styles to further reduce vertical spacing */
.v-input--checkbox {
  padding: 0;
}

.v-messages {
  min-height: 0;
}

.v-expansion-panel-header>*:not(.v-expansion-panel-header__icon) {
  flex-shrink: 0 !important;
}

.checkbox-item {
  font-size: 0.85rem;
  line-height: 1.1rem;
  margin-bottom: 4px;
  text-align: left;
}

.checkbox-item label {
  display: flex;
  align-items: center;
  text-align: left;
}

.checkbox-item input[type="checkbox"] {
  margin-right: 8px;
  margin-left: 10px;
  text-align: left;
}
</style>
